import { ADD_APPOINTMENT_INFO } from "../actions/type";

const initialState = {
  appointment: [],
};

export const appointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_APPOINTMENT_INFO:
      return {
        ...state,
        appointment: action.appointment,
      };
    default:
      return state;
  }
};
export default appointmentReducer;
